<template>
  <div class="r-form">
    <default-text-input
      :value="firstName"
      label="שם פרטי"
      validations="required|nameCharacters"
      class="r-form-row"
      :tabindex="1"
      @observe="observe"
      @input="setFirstName"/>
    <default-text-input
      :value="lastName"
      label="שם משפחה"
      validations="required|nameCharacters"
      class="r-form-row"
      :tabindex="2"
      @observe="observe"
      @input="setLastName"/>
    <social-id-number-input :social-id-number="idNumber" class="r-form-row" @input="setSocialIdNumber" @observe="observe" :tabindex="3"/>
    <birth-date :value="birthDate" class="r-form-row" @input="setBirthDate" @observe="observe" :tab-index-seed="4"/>
    <default-text-input
      :value="address"
      label="כתובת מגורים"
      validations="required|freeTextAddress"
      class="r-form-row"
      :tabindex="10"
      @observe="observe"
      @input="setAddress" />
  </div>
</template>

<script>
import BirthDate from '@/components/base/BirthDate';
import ValidationObserver from '@/mixins/ValidationObserver';
import SocialIdNumberInput from '@/components/SocialIdNumberInput';
import DefaultTextInput from '@/components/styled/DefaultTextInput';

export default {
  name: 'BeneficiaryForm',
  components: { DefaultTextInput, SocialIdNumberInput, BirthDate },
  mixins: [ValidationObserver],
  data() {
    return {
      beneficiary: {
        firstName: this.firstName,
        lastName: this.lastName,
        socialIdNumber: this.socialIdNumber,
        birthDate: this.birthDate,
        address: this.address,
      },
    };
  },
  props: {
    firstName: String,
    lastName: String,
    idNumber: String,
    birthDate: String,
    address: String,
  },
  methods: {
    setFirstName(value) {
      this.beneficiary.firstName = value;
      this.emitBeneficiary();
    },
    setLastName(value) {
      this.beneficiary.lastName = value;
      this.emitBeneficiary();
    },
    setSocialIdNumber(value) {
      this.beneficiary.idNumber = value;
      this.emitBeneficiary();
    },
    setBirthDate(value) {
      this.beneficiary.birthDate = value;
      this.emitBeneficiary();
    },
    setAddress(value) {
      this.beneficiary.address = value;
      this.emitBeneficiary();
    },
    emitBeneficiary() {
      this.$emit('beneficiary', this.beneficiary);
    },
  },
};
</script>
